import { RootState } from "../store/root-reducer";

const favoritesSelector = (state: RootState) => state.favorites;

export { favoritesSelector };
